import { SerializedError, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { VideoSlider } from "data/types";

import { RootState } from "redux/store";
import { videoApi } from "./videoSliderAPI";

interface VideoState {
  loading: "idle" | "pending" | "succeeded" | "failed";
  videoError: string;
  error: SerializedError | "";
  allVideos: VideoSlider[];
  videoData?: any;
  totalCount?: number;
  totalPages?: number;
}

const initialState: VideoState = {
  loading: "idle",
  videoError: "",
  error: "",
  allVideos: [],
  videoData: undefined,
  totalCount: 0,
  totalPages: 0,
};

export const addVideoSlider = createAsyncThunk("addVideo", async (data: any) => {
  return await videoApi.addVideo(data);
});

export const getAllVideosSlider = createAsyncThunk("getAllVideosSlider", async () => {
  return await videoApi.getAllVideos();
});

export const adminGetAllVideosSlider = createAsyncThunk("adminGetAllVideosSlider", async (page: any) => {
  return await videoApi.adminGetAllVideos(page);
});

export const getVideoSliderById = createAsyncThunk("getVideoSliderById", async (id: string) => {
  return await videoApi.getVideoById(id);
});

export const deleteVideoSlider = createAsyncThunk("deleteVideo", async (id: string) => {
  return await videoApi.deleteVideo(id);
});

export const updateVideoSlider = createAsyncThunk(
  "updateHomeVideo",
  async ({ data, id }: { data: any; id: any }) => {
    return await videoApi.updateHomeVideo(data, id);
  }
);

export const sliderVideo = createSlice({
  name: "homeVideo",
  initialState,
  reducers: {
    setError(state, action) {
      state.error = action.payload;
    },
    initStates(state) {
      state.loading = "idle";
      state.videoData = undefined;
      state.error = "";
      state.videoError = "";
      state.allVideos = [];
    },
  },
  extraReducers: (builder) => {
    // add video
    builder.addCase(addVideoSlider.pending, (state, action) => {
      state.loading = "pending";
      state.videoError = "";
    });
    builder.addCase(addVideoSlider.fulfilled, (state, action) => {
      if (action.payload.status === "OK") {
        state.loading = "succeeded";
      }
      if (action.payload.status === "VALIDATION") {
        state.loading = "failed";
        state.videoError = action.payload.error[0].msg ?? "failed";
      }
      if (action.payload.status === "ERROR") {
        state.loading = "failed";
        state.videoError = action.payload.error;
      }
    });
    builder.addCase(addVideoSlider.rejected, (state, action) => {
      state.loading = "failed";
    });

    // get all videos

    builder.addCase(getAllVideosSlider.fulfilled, (state, action) => {
      state.allVideos = action.payload;
    });

    builder.addCase(adminGetAllVideosSlider.fulfilled, (state, action) => {
      state.allVideos = action.payload.videos;
      state.totalCount = action.payload.totalCount;
      state.totalPages = action.payload.totalPages;
    });

    builder.addCase(getVideoSliderById.fulfilled, (state, action) => {
      state.videoData = action.payload;
    });

    // update
    builder.addCase(updateVideoSlider.pending, (state, action) => {
      state.loading = "pending";
      state.videoError = "";
    });
    builder.addCase(updateVideoSlider.fulfilled, (state, action) => {
      if (action.payload.status === "OK") {
        state.loading = "succeeded";
      }
      if (action.payload.status === "VALIDATION") {
        state.loading = "failed";
        state.videoError = action.payload.error[0].msg ?? "failed";
      }
      if (action.payload.status === "ERROR") {
        state.loading = "failed";
        state.videoError = action.payload.error;
      }
    });
    builder.addCase(updateVideoSlider.rejected, (state, action) => {
      state.loading = "failed";
    });
  },
});

export const { initStates, setError } = sliderVideo.actions;

export const selectCount = (state: RootState) => state.videoHome;
export default sliderVideo.reducer;
